import React, { useState, useEffect } from "react";
import { Card, Button, Row, Col } from "react-bootstrap";
import {
    convertsSecondsToTime,
    convertDateToReadable,
} from "../../../../utils/general";
import { useRecordings } from "../../../../contexts/RecordingsContext";
function Recordings({ id }) {
    const {recordings, getRecordings} = useRecordings();

    useEffect(() => {
        if (id) {
            getRecordings(id);
        }
    }, [id, getRecordings]);
    return (
        <div
            style={{
                padding: "20px",
                color: "black",
                height: "100%",
                position: "absolute",
                top: "0",
            }}
            className="w-100 bg-white"
        >
            <h2 className="text-center mt-5">Recordings</h2>

            {recordings.length > 0 ? (
                <>
                    <Row className="overflow-auto">
                        {recordings.map((recording) => (
                            <Col xs={12} md={4} lg={3} key={recording.id}>
                                <Card className="mb-4">
                                    <Card.Img
                                        variant="top"
                                        src={`https://recordings.churchcamlive.ie/${recording.video_guid}/${recording.thumbnail_file_name}`}
                                    />
                                    <Card.Body>
                                        <Card.Title>
                                            {recording.recording_name}
                                        </Card.Title>
                                        <Card.Text class="text-sm">
                                            Duration:{" "}
                                            {convertsSecondsToTime(
                                                recording.length_s
                                            )}
                                        </Card.Text>
                                        <Card.Text>
                                            Date:{" "}
                                            {convertDateToReadable(
                                                recording.date_uploaded
                                            )}
                                        </Card.Text>
                                        <Button
                                            variant="outline-dark"
                                            href={recording.recording_url}
                                            target="_blank"
                                            rel="noopener noreferrer"
                                        >
                                            Watch Recording
                                        </Button>
                                    </Card.Body>
                                </Card>
                            </Col>
                        ))}
                    </Row>
                </>
            ) : (
                <p className="text-center">
                    No recordings available for this live stream.
                </p>
            )}
        </div>
    );
}

export default Recordings;
